import socket from "@/socket.js";

export default {
    setFriendRequests(state, payload) {
        state.friendRequests = payload;
    },
    updateUserStatus(state, payload) {
        try {
            const user = state.onlineStatus.find(user => user.userID === payload.userID);
            if (user) {
                user.connected = payload.connected;
            } else {
                state.onlineStatus.push(payload);
            }
        } catch (error) {
            console.log(error);
        }
    },
    fetchUserStatus(state, payload) {
        state.onlineStatus = payload;
    },
    getFriendStatus(_, payload) {
        socket.emit('user:status', { token: payload.token });
    }
}
